class viewCartOptionsController {
    /* @ngInject */
    constructor() {
    }
}

export default viewCartOptionsController;


// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-options/view-cart-options.controller.js